import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { ComponentType } from '../../utils/events/types';
import { InspireCard } from '../internal/InspireCard';
import { Masonry, MasonryCard } from '../internal/Masonry';
import { CollectionsContextProvider } from '../internal/context/CollectionsContext';
import { MixpanelContextProvider } from '../internal/context/events/MixpanelContext';
import { BigQuery } from '../internal/BigQuery';
import { BigQueryImpressionContainer } from '../internal/BigQueryImpressionContainer';
import type { InspireGridProps } from './types';

export const InspireGrid = ({
  inspireDeliveries,
  isTouch: isTouchFromProps,
  mixpanelEnabled,
  mixpanelOptions,
  bigQueryEnabled,
  bigQueryOptions,
  cardHrefRouteOptions,
  ...collectionsData
}: InspireGridProps) => {
  const { isTouch: isTouchFromContext } = getContext();
  const isTouch = isTouchFromProps !== undefined ? isTouchFromProps : Boolean(isTouchFromContext);
  return (
    <MixpanelContextProvider
      componentType={ComponentType.Waterfall}
      mixpanelEnabled={mixpanelEnabled}
      mixpanelOptions={mixpanelOptions}
      inspireDeliveries={inspireDeliveries}
    >
      <BigQuery variant="waterfall" bigQueryEnabled={bigQueryEnabled} bigQueryOptions={bigQueryOptions}>
        <CollectionsContextProvider {...collectionsData}>
          <BigQueryImpressionContainer intersectionThreshold={0.1}>
            <Masonry>
              {inspireDeliveries.map((inspireDelivery, index) => (
                <MasonryCard key={inspireDelivery.id}>
                  <InspireCard
                    isTouch={isTouch}
                    index={index}
                    inspireDelivery={inspireDelivery}
                    cardHrefRouteOptions={cardHrefRouteOptions}
                  />
                </MasonryCard>
              ))}
            </Masonry>
          </BigQueryImpressionContainer>
        </CollectionsContextProvider>
      </BigQuery>
    </MixpanelContextProvider>
  );
};
